import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class B2BMixReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/b2bDailyMixReport',
      requesterInfo,
    })
  }

  // Mails boş bırakılırsa koddaki varsayılan adreslere gönderilir.
  public async sendB2BMixReport(req: { StartDate: Date; EndDate: Date; Mails?: string[] }): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
